import React from 'react';
import {Radio} from 'antd';
import VStack from '../Layout/VStack';
import CustomCheckbox from '../CustomCheckbox';

const ChoiceQuestion = ({question, value, onChange, disabled}) => {
    const checkedAnswers = Array.isArray(value) ? value : [];
    const getAnswersWithChecked = (answer, isChecked) => question.answers.map((option) => (option.id === answer.id ? {...answer, checked: isChecked} : option));
    const selectAnswer = (answerText) => {
        const answer = question.answers.find((option) => option.answer_text === answerText);
        onChange(answerText, {answers: getAnswersWithChecked(answer, true)});
    };
    const toggleAnswer = (answer, isChecked) => onChange(isChecked ? [...checkedAnswers, {...answer, checked: true}] : checkedAnswers.filter((checkedAnswer) => checkedAnswer.id !== answer.id), {answers: getAnswersWithChecked(answer, isChecked)});

    if (!Number(question.multi_choice)) {
        return (
            <Radio.Group value={value} disabled={disabled} onChange={(e) => selectAnswer(e.target.value)}>
                <VStack space={'0.5rem'}>
                    {question.answers.map((answer) => <Radio key={answer.id} value={answer.answer_text}>{answer.answer_text}</Radio>)}
                </VStack>
            </Radio.Group>
        );
    }

    return (
        <VStack space={'0.5rem'}>
            {question.answers.map((answer) => (
                <CustomCheckbox key={answer.id} text={answer.answer_text} isChecked={checkedAnswers.some((checkedAnswer) => checkedAnswer.id === answer.id)} onChange={(isChecked) => toggleAnswer(answer, isChecked)} disabled={disabled} />
            ))}
        </VStack>
    );
};

export default ChoiceQuestion;
